import { getPhoneNumbers } from 'pricing-pages-lib/api/PhoneNumbersApi';
import { PHONE_NUMBERS } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchPhoneNumbersRequestTypes = createRequestTypes(PHONE_NUMBERS);
export const FetchPhoneNumbersActions = createRequestActions(FetchPhoneNumbersRequestTypes);
export const fetchPhoneNumbers = () => makeFetchRequest({
  requestActions: FetchPhoneNumbersActions,
  fetch: getPhoneNumbers
});